import __request__ from "routing/request";
export function testLookupTable(JSONbody, requestOptions) {
  return __request__("POST", "/tools/lookup_table_tester", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testLookupTableBylookup_table_nameAndstring(lookup_table_name, string, requestOptions) {
  return __request__("GET", "/tools/lookup_table_tester", null, { "lookup_table_name": lookup_table_name, "string": string }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
